<template>
    <div>
        <div class="main-content"  v-if="showBlank.hasError == 200">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-8">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											Edit Article / Blog
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>

						<!-- Content -->

						<div class="mt-3 mb-5">
							<div>
								<p>Fields marked <span class="text-danger">*</span> are required</p>
							</div>

							<!-- form -->
							<form id="addArticleForm">
								<div class="form-group">
									<div class="row">
										<div class="col-md-5">
											<label for="">Title <span class="text-danger">*</span></label>
											<input type="text" name="title" id="title" class="form-control"
												v-model="addData.title" v-validate="'required'"
											>
											<!-- <span v-if="nameError" class="text-danger d-block">The title field is required</span> -->
											<span class="text-danger d-block">{{ errors.first('title') }}</span>

										</div>

                                        <div class="col-md-5">
											<label for="">Subtext <span class="text-danger">*</span></label>
											<input type="text" name="subtext" id="subtext" class="form-control"
												v-model="addData.subtext" v-validate="'required'"
											>
											<span class="text-danger d-block">{{ errors.first('subtext') }}</span>

										</div>
									</div>
								</div>

                                <div class="form-group">
                                    <label class="d-block" id="status">Status <span class="text-danger">*</span></label>
                                    <span class="text-danger d-block">{{ errors.first('status') }}</span>
                                    
                                    <div class="row">
                                        <div class="col-md-5">
                                            

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="status1" name="status" class="custom-control-input"
                                                    v-model="addData.status" value="1" v-validate="'required|included:1,2'"
                                                >
                                                <label class="custom-control-label" for="status1">Published</label>
                                            </div>

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="status2" name="status" class="custom-control-input"
                                                    v-model="addData.status" value="2"
                                                >
                                                <label class="custom-control-label" for="status2">Draft</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

								<div class="form-group">
									<label for="">Excerpt Image</label>
									<small class="d-block mb-3">This image will appear at the top of this article's page</small>

									<div class="row">
										<div class="col-md-5">

											<div v-show="!hasImage">
												<input type="file" name="excerptimage" id="file-1" class="custom-input-file" accept="image/*" v-on:change="insertImg($event)"
												/>

												<label for="file-1">
													<i class="fe fe-folder-plus"></i>  <span>Choose a file…</span>
												</label>
											</div>

											<div v-show="hasImage">
												<div class="excerptimage-container">
													<img id="excerpt-img">

													<button class="btn btn-danger btn-sm" @click.prevent="removeExcerptImg($event)"
                                                        data-expunge-img="" data-img-mask="" id="removeExcerptImg"
                                                    >
														<i class="fe fe-x"></i>
													</button>
												</div>
											</div>

										</div>
									</div>
								</div>

								<div class="form-group">
									<label for="">Content <span class="text-danger">*</span></label>
									<span v-if="contentError" class="text-danger d-block">The content field is required</span>

									<quill-editor v-model="addData.content"
										ref="myQuillEditor"
										:options="editorOption"
									>
									</quill-editor>

								</div>

								<div class="form-group">
									<div class="row">
										<div class="col-md-4 offset-md-4">
											<button class="btn btn-success btn-block"
												v-on:click.prevent="updateBlog($event)"
											>
												Save
											</button>
										</div>
									</div>
								</div>


							</form>
						</div>

					</div>
				</div>
			</div>


		</div>

        <div v-if="showBlank.hasError == 400">
			<div class="main-content">
				<div class="container mt-5">
					<div class="row d-flex justify-content-center mt-5">
						<div class="col-md-8 offset-md-2">
							<h1 class="display-1">404</h1>
							<p>The page you requested cannot be found</p>
						</div>
					</div>
				</div>
			</div>
		</div>

    </div>
</template>

<script>
    import editorOption from '@/assets/js/editorsettings.js'

	// require styles
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'
    import axios from 'axios';
	
	export default {
		components: {
			quillEditor
		},
        name: 'Add',
        data() {
            return {
				addData: {
					title: '',
                    content: '',
                    subtext: '',
                    status: 1
				},
				editorOption: editorOption.editorOption,
				hasImage: false,
                contentError: false,
                showBlank: {
                    hasError: null, 
                    msg: '', 
                }
			}
		},
		metaInfo() {
			return {
				title: this.addData.title
			}
		},
        methods: {
            //fetch article
            fetchArticle() {
                var self = this;
                var id = this.$route.params.articleid;
				var dash = this.$route.params.articledash;
				
                $.getJSON(APIURL + 'admin/articles/' + id + '/' + dash, function(response) {

                    if (response.status == 200) {
                        self.showBlank.hasError = 200;
                        self.addData.title = response.data.title;
                        self.addData.content = response.data.content;
                        self.addData.status = response.data.status;
                        self.addData.subtext = response.data.subtext;

                        if (response.data.image !== '') {
                            self.hasImage = true;
                            setTimeout(() => {
                                var img = document.querySelector('#excerpt-img');
                                var removeBtn = document.querySelector('#removeExcerptImg');

                                img.setAttribute('src', response.data.image);
                                img.classList.add('img-object-fit');

                                removeBtn.dataset.expungeImg = true;
                                removeBtn.dataset.imgMask = response.data.imagemask;
                            }, 1000);
                        }

                    }
                    else if (response.status == 203) {

                    }
                    else {
                        self.showBlank.hasError = 400;
                    }
                })
            },

            //Add blog
            updateBlog(e) {
                var self = this;
				var btn = e.currentTarget;
				var sve = document.querySelector('.s-v-e');
                if (sve) sve.remove();
                var id = this.$route.params.articleid;
                
                //vars
				var content = this.addData.content.trim();
				var name = this.addData.title.trim();
				var subtext = this.addData.subtext.trim();
				var status = this.addData.status;
				var file = document.querySelector('#file-1').files[0];

				this.$validator.validateAll().then((result) => {
					if (result) {
						if (!content) {
							this.contentError = true; 
							return false;
						}
						this.contentError = false;

						const formData = new FormData();
						formData.append('title', this.addData.title);
						formData.append('content', this.addData.content);
						formData.append('subtext', this.addData.subtext);
						formData.append('status', this.addData.status);

						if (file) formData.append('excerptimage', file, file.name);

						$.ajax({
							type: 'POST', url: APIURL + 'admin/articles/update/' + id, data: formData, dataType: 'JSON', contentType: false,
							processData: false, cache: false, async: false,
							beforeSend()  { 
								btn.setAttribute('disabled', ''); 
								btn.classList.add('is-loading'); 
								btn.classList.add('is-loading-sm');
							}, 
							success(response) {
								btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); 
								btn.classList.remove('is-loading-sm');

								if (response.status == 200) {
                                    
                                    self.$swal('', response.msg, 'success');
                                    self.$router.replace('/dashboard/articles/' + response.data.articleid + '/' + response.data.dash);
									
								}
								else {
									if (response.status == 403) {
										$.each(response.errors, function(k, v) {
											$('#' + k).after(v);
										})
									}
									else {
										self.$swal('', response.msg, 'error');
									}
								}
							}
						});
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			
			// insert image
			insertImg(e) {
				var file = e.currentTarget.files[0];
				var t = file.type.split('/').pop().toLowerCase();
				
				if (t != 'jpeg' && t != 'jpg' && t != 'png') {
					this.$swal('', 'File must be of type jpg, jpeg or png'); 
					return false;
				}

				if (file.size > 2097152) {
					this.$swal('', 'File size must be less than 2MB', 'error');
					return false;
				}

				var src = URL.createObjectURL(file);
				var excerptimg = document.querySelector('#excerpt-img');
				excerptimg.classList.add('img-object-fit');
				excerptimg.setAttribute('src', src);
				this.hasImage = true;
			},

			//remove thumb img
			removeExcerptImg(e) {
				var btn = e.currentTarget;
                var expunge = btn.dataset.expungeImg;
                var imgMask = btn.dataset.imgMask;

                if (expunge) {
                    var confirm = window.confirm('Are you sure to delete this image permanently?');
                    if (confirm) {
                        axios.get(APIURL + 'expungefile/' + imgMask).then((response) => {
                            if (response.status !== 200) {
                                this.$swal('', response.msg, 'error');
                                return false;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                    }
                }
				this.hasImage = false;
				document.querySelector('#excerpt-img').removeAttribute('src');
				document.querySelector('#file-1').value = '';
			}
        },
        created() {
            this.fetchArticle();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/articles/Edit.vue